var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 283,
    viewBox: "0 0 404 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7614_50254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1152 258.722C127.849 247.612 165.842 244.87 205.272 253.018C242.258 260.661 280.696 277.311 318.215 281.416C329.006 282.597 340.305 282.681 350.243 278.219C360.181 273.758 368.398 263.766 368.026 252.665C367.741 244.135 362.71 236.673 358.476 229.319C353.172 220.107 348.873 210.288 345.687 200.105C343.83 194.174 342.336 187.964 342.94 181.766C344.459 166.181 358.178 155.366 370.152 145.613C384.04 134.301 394.069 118.616 401.146 101.958C408.223 85.2993 401.327 63.4804 389.33 50.0946C379.552 39.1845 364.269 35.312 349.811 34.8331C320.098 33.8478 299.295 48.1226 270.825 39.3661C257.38 35.2308 245.564 27.0028 233.116 20.3615C201.405 3.44722 164.576 -3.24225 129.113 1.47244C106.932 4.42154 83.4122 13.2661 72.2685 33.1143C64.7543 46.4987 64.1336 63.1309 68.0679 78.0332C70.6366 87.7626 75.0579 97.8705 72.1609 107.504C70.2131 113.981 65.2482 118.975 60.3716 123.56C45.1349 137.889 28.7904 151.32 16.59 168.424C4.39099 185.529 -3.35635 207.39 1.43608 227.99C5.01177 243.359 15.674 256.834 29.6195 263.609C43.565 270.383 59.8722 268.773 74.4026 263.441C85.3408 259.426 74.6606 262.867 89.1138 258.722H89.1152Z",
    fill: "url(#paint0_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.709 281.227C316.639 290.235 234.167 262.01 234.167 262.01C234.167 262.01 232.169 246.49 233.062 243.227C233.953 239.966 336.859 245.836 335.966 253.251C335.128 260.227 337.707 281.227 337.707 281.227H337.709Z",
    fill: "url(#paint1_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92 144.091C145.92 144.091 139.231 142.46 134.327 142.905C129.423 143.349 116.193 145.92 115.004 147.749C113.815 149.578 138.042 158.326 143.988 152.395C149.933 146.464 145.92 144.091 145.92 144.091Z",
    fill: "#71B0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.627 178.421C324.931 172.274 295.979 146.16 279.421 133.369C275.144 130.065 271.708 125.794 269.467 120.883C268.709 119.219 268.19 117.81 268.19 117.134C268.19 114.762 269.787 111.601 270.568 107.249C271.757 100.626 263.533 94.2008 259.965 97.3646C256.398 100.528 259.569 104.086 258.776 105.272C257.983 106.458 262.244 91.4334 249.957 90.2471C237.67 89.0609 217.06 86.6884 216.662 97.7595C216.266 108.831 219.834 117.134 221.815 120.297C223.797 123.461 228.95 137.694 234.498 140.462C237.259 141.839 238.968 145.607 241.236 147.776C232.374 155.105 224.672 160.841 221.418 162.207C213.887 165.371 208.337 199.77 203.582 206.887C198.825 214.004 156.811 210.051 156.415 214.399C156.019 218.749 158.397 223.493 157.604 227.448C156.811 231.402 161.965 236.542 167.909 236.147C173.855 235.752 180.196 234.96 178.214 232.588C176.232 230.215 172.268 223.098 168.305 222.703C164.342 222.308 167.116 221.122 176.629 219.539C186.142 217.958 324.075 209.654 266.602 245.635C265.54 246.3 252.382 242.769 247.23 238.419C242.077 234.069 236.825 230.264 231.723 234.959C228.401 238.016 213.094 227.447 209.922 229.028C206.751 230.609 211.111 233.773 211.507 236.145C211.903 238.518 207.147 234.959 208.336 238.518C209.525 242.077 208.236 245.141 211.011 246.327C213.785 247.514 209.128 249.589 213.488 251.961C217.847 254.334 236.478 265.8 244.404 266.195C252.331 266.59 261.051 265.8 265.412 266.986C269.771 268.172 326.451 267.381 332.397 257.893C338.342 248.403 335.964 186.722 329.622 178.419L329.627 178.421Z",
    fill: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.162 176.415C167.284 157.431 160.801 148.998 154.84 147.551C153.473 147.22 150.691 147.488 149.488 146.76C148.419 146.112 144.535 147.748 141.462 143.498C140.865 142.673 140.691 141.696 140.382 140.877C140.843 139.748 141.218 138.543 141.462 137.271C142.948 129.561 143.543 129.265 144.137 126.002C144.732 122.741 142.652 119.182 142.057 121.554C141.462 123.927 143.841 110.878 137.598 107.617C131.356 104.355 117.681 103.169 115.897 113.251C114.114 123.334 116.194 127.484 116.194 127.484C116.194 127.484 117.878 137.731 120.257 140.401C120.904 141.127 121.517 142.589 122.82 143.709C122.267 145.971 121.78 148.611 120.207 149.577C116.343 151.949 121.842 170.186 125.707 177.008C127.615 180.375 131.842 177.743 135.918 173.358C143.776 175.296 163.248 179.061 167.324 188.277C171.783 198.36 157.217 206.662 157.217 206.662C157.217 206.662 178.918 203.104 180.403 196.283C181.889 189.463 174.612 177.663 174.161 176.415H174.162Z",
    fill: "#FFD9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.813 157.041C107.166 155.504 107.318 153.797 107.803 152.296C108.587 149.875 110.743 143.523 110.743 140.929C110.743 136.777 111.733 135.492 106.086 132.823C100.438 130.155 87.0608 139.348 84.9791 142.609C82.8988 145.87 83.1623 137.996 80.5205 139.643C78.9065 140.649 75.764 145.87 78.1422 149.429C80.5205 152.988 79.9259 154.767 78.4388 158.029C76.9517 161.29 66.8454 173.153 61.1977 175.821C55.55 178.489 40.9837 224.751 40.3891 232.461C39.7945 240.17 42.0238 244.174 47.6716 243.581C53.3193 242.988 68.3311 238.392 76.0605 232.461C83.79 226.529 92.1374 223.351 94.4908 222.082C98.1576 220.104 103.905 217.634 105.39 216.744C106.876 215.855 107.373 225.178 107.373 225.178L115.233 216.545C115.233 216.545 112.571 210.025 107.748 208.411C103.292 206.919 93.0037 211.108 91.22 211.999C89.4363 212.888 75.4646 219.017 67.8345 220.895C60.4762 222.707 55.5472 225.64 52.2777 227.716C49.0083 229.791 58.52 227.123 62.0875 219.412C65.6549 211.701 66.844 201.916 70.708 198.654C74.5721 195.393 102.515 197.468 101.326 189.164C100.137 180.86 94.0273 180.993 92.6395 175.458C92.2781 174.014 92.525 171.671 93.201 171.62C94.9185 171.488 96.9105 173.132 101.855 165.936C104.306 162.369 105.686 161.933 106.809 157.039L106.813 157.041Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.127 111.601C264.127 111.601 266.802 110.909 266.307 108.536C265.812 106.164 266.703 106.263 265.118 105.571C263.533 104.878 262.74 102.803 264.227 102.012C265.713 101.221 267.993 102.308 268.389 104.384C268.785 106.46 268.685 99.9366 265.812 100.232C262.938 100.528 259.669 101.913 261.749 104.087C263.83 106.261 263.732 111.897 264.127 111.599V111.601Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.652 122.869C239.472 123.125 238.067 123.067 238.363 120.891C238.66 118.716 242.129 118.223 243.814 117.332C245.498 116.442 240.346 121.879 239.652 122.867V122.869Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.715 125.341C232.481 125.072 230.337 123.166 227.563 123.858C224.788 124.551 228.454 123.958 230.535 124.847C232.616 125.736 233.409 127.417 234.202 130.284C234.995 133.15 236.283 136.412 235.292 137.5C234.302 138.587 231.625 135.326 230.931 133.547C230.238 131.767 229.346 130.383 229.742 129.79C230.138 129.197 227.265 129.197 227.364 127.219C227.463 125.241 226.473 123.958 224.787 123.561C223.103 123.166 220.031 116.741 220.328 114.763C220.625 112.786 220.428 107.449 220.428 107.449C220.428 107.449 218.149 107.943 217.95 109.229C217.752 110.514 218.445 114.073 219.338 115.753C220.229 117.433 228.454 133.644 229.544 135.424C230.633 137.203 232.417 139.476 234.002 140.464C235.587 141.453 241.069 146.035 241.896 146.759C242.722 147.483 245.298 151.536 247.676 151.042C250.054 150.548 251.243 150.942 255.702 146.001C260.161 141.059 263.133 138.389 263.133 138.389C263.133 138.389 252.135 147.78 250.351 148.472C248.567 149.164 245 148.472 244.306 147.286C243.612 146.1 238.658 142.245 237.469 141.849C236.28 141.454 235.785 139.181 236.28 138.488C236.775 137.796 237.568 140.466 239.153 139.873C240.738 139.28 241.828 140.565 242.225 139.577C242.621 138.589 243.55 136.086 244.703 135.722C246.586 135.129 245.892 133.844 245 134.141C244.107 134.438 242.027 138.293 240.937 138.392C239.847 138.491 237.766 138.886 237.568 137.997C237.37 137.108 235.389 128.409 232.712 125.345L232.715 125.341Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.083 133.051C247.083 133.051 254.119 134.929 254.317 136.016C254.516 137.104 255.11 138.587 255.11 138.587C255.11 138.587 255.904 135.028 254.814 134.83C253.724 134.632 248.174 133.249 247.084 133.051H247.083Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.691 128.981C227.691 128.981 228.697 130.21 230.106 129.264C231.514 128.319 231.111 127.184 231.111 127.184L227.693 128.981H227.691Z",
    fill: "#727495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.186 122.814C243.186 122.814 245.033 123.963 246.077 123.224C247.122 122.485 247.282 120.926 247.282 120.926L243.185 122.814H243.186Z",
    fill: "#727495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.237 121.355C241.013 121.272 242.426 122.804 242.492 123.134C242.558 123.464 243.549 122.212 241.237 121.355Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82 123.599C241.82 123.599 242.038 122.658 242.401 122.223C242.764 121.788 245.96 121.498 247.776 120.122C249.591 118.745 247.413 121.136 246.178 121.571C244.944 122.005 241.82 123.599 241.82 123.599Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.685 126.52C231.713 126.5 231.688 126.458 231.657 126.471C230.781 126.89 229.547 127.914 228.021 128.348C227.014 128.636 226.705 129.533 226.342 129.895C225.979 130.257 228.941 128.547 229.71 128.24C230.799 127.805 231.02 126.985 231.684 126.518L231.685 126.52Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.661 142.443C238.661 142.443 241.714 142.111 243.368 141.356C245.746 140.269 247.062 139.184 248.274 138.192C249.661 137.055 250.553 136.117 251.395 135.919C252.238 135.72 252.535 135.919 251.742 136.264C250.948 136.609 246.935 140.021 245.152 140.811C243.368 141.602 241.584 142.442 239.256 142.886C237.004 143.317 238.216 142.837 238.661 142.442V142.443Z",
    fill: "#E5B095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.211 145.573C244.106 145.747 245.298 144.635 246.642 144.119C247.986 143.603 249.455 143.349 247.94 143.053C246.425 142.757 246.518 142.319 246.925 141.714C247.332 141.108 245.011 142.969 243.479 143.367C241.946 143.764 245.578 143.272 244.21 145.573H244.211Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.175 121.14C237.017 120.983 236.58 119.065 237.373 118.075C238.166 117.087 238.067 117.482 237.868 118.569C237.67 119.657 237.769 117.778 239.058 117.087C240.346 116.395 243.12 115.407 245.498 114.517C247.877 113.628 250.156 114.912 250.156 114.912C250.156 114.912 245.994 115.9 243.814 116.987C241.634 118.074 237.868 121.831 237.175 121.139V121.14Z",
    fill: "url(#paint2_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.693 124.053C229.915 123.832 230.684 123.065 229.297 122.472C227.91 121.879 226.82 122.176 226.82 122.176L228.009 122.769C228.009 122.769 225.73 121.978 224.739 123.263C223.749 124.549 224.046 125.241 224.046 125.241C224.046 125.241 225.631 124.747 227.118 124.253C228.603 123.759 228.802 124.945 229.695 124.054L229.693 124.053Z",
    fill: "url(#paint3_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75 131.832C131.75 131.832 130.462 128.273 130.957 127.087C131.452 125.901 132.246 124.814 134.129 124.221C136.012 123.628 137.729 123.694 137.729 123.694C137.729 123.694 133.633 125.111 133.931 126.395C134.229 127.679 133.535 128.569 135.021 128.966C136.507 129.362 134.13 130.053 133.237 129.855C132.346 129.656 132.444 132.82 131.752 131.832H131.75Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.391 130.35C126.367 127.384 123.56 126.758 122.073 126.857C120.587 126.956 117.581 128.176 117.581 128.176C117.581 128.176 119.563 129.955 121.743 129.856C123.923 129.757 126.697 132.03 126.896 133.316C127.094 134.601 127.589 136.182 127.391 137.073C127.192 137.962 127.687 139.346 129.373 139.445C131.058 139.544 132.841 138.358 132.841 138.358C132.841 138.358 131.652 137.765 130.859 137.567C130.066 137.368 128.58 138.061 128.381 137.567C128.183 137.073 128.481 132.526 128.183 132.129C128.067 131.975 127.518 130.722 127.389 130.35H127.391Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.869 142.805C129.869 142.805 133.536 141.817 134.031 142.014C134.526 142.212 132.247 143.992 131.852 143.794C131.456 143.595 129.869 142.805 129.869 142.805Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38 142.707C139.281 143.003 136.506 147.551 133.93 148.242C131.536 148.885 127.192 147.748 124.714 145.574L122.819 143.709C122.819 143.709 122.137 147.748 120.948 148.44C119.759 149.132 118.868 153.382 119.363 156.25C119.859 159.116 127.787 154.865 130.362 153.185C132.939 151.505 136.308 149.824 137.794 147.254C139.279 144.683 139.379 142.707 139.379 142.707H139.38Z",
    fill: "#EAB695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.427 116.414C123.427 116.414 119.661 117.995 118.671 120.961C117.68 123.926 117.283 127.287 118.374 128.275C119.464 129.263 118.869 130.548 118.671 131.34C118.472 132.131 118.275 136.974 120.059 139.544C121.842 142.115 124.419 145.277 124.419 145.277C124.419 145.277 118.672 140.664 117.284 134.008C115.95 127.609 115.005 125.012 114.807 123.728C114.608 122.443 115.103 119.675 117.284 117.896C119.464 116.117 127.589 106.825 123.427 116.414Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.084 140.556C126.084 140.556 126.17 140.493 127.555 140.371C130.165 140.14 130.758 140.009 134.887 138.79C137.657 137.972 132.153 140.708 126.083 140.558L126.084 140.556Z",
    fill: "#FFC395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.279 155.098C103.372 154.925 102.518 159.744 102.717 160.864C102.916 161.985 102.189 162.512 101 162.446C99.8105 162.38 99.6118 162.907 100.67 163.303C101.727 163.698 102.85 163.237 103.114 162.512C103.379 161.786 102.818 155.954 103.28 155.098H103.279Z",
    fill: "#C97E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 151.258C105.177 151.305 103.823 152.971 103.56 153.631C103.295 154.29 102.716 159.299 103.135 158.32C103.837 156.686 104.184 154.365 104.699 153.68C105.778 152.249 111.062 150.814 105.74 151.258Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.582 164.307C95.4591 164.043 93.9319 163.071 94.5265 162.808C95.1211 162.544 96.0702 164.044 96.9296 164.307C97.7891 164.571 100.896 165.806 102.024 165.806C103.412 165.806 101.496 166.663 101.034 166.07C100.572 165.477 96.5834 164.307 96.5834 164.307H96.582Z",
    fill: "#B06D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8445 152.793C97.7756 153.068 97.5893 154.191 98.2584 154.307C99.4972 154.519 99.6627 153.431 99.6627 153.431L97.8445 152.793Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4912 165.887C96.4912 165.887 99.2654 166.612 98.7371 166.941C98.2087 167.27 96.7547 166.546 96.4912 165.887Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8223 151.734C95.8223 151.734 97.1769 151.999 98.3661 152.46C99.5552 152.921 100.968 152.958 101.768 152.888C101.768 152.888 100.579 153.745 99.918 153.679C99.2573 153.613 97.0776 152.294 95.8223 151.734Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.123 150.122C102.123 150.122 102.585 149.134 100.273 148.408C97.961 147.683 96.1773 147.815 95.5165 147.947C94.8557 148.08 97.3002 147.881 98.6218 148.541C99.9433 149.2 101.661 151.242 102.123 150.122Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.417 150.683C107.672 150.418 108.729 151.21 107.738 151.342C106.748 151.474 105.261 151.704 105.393 151.177C105.525 150.65 105.313 150.914 106.417 150.683Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0685 159.483C81.372 160.314 81.79 161.097 82.3101 161.814C83.7475 163.793 86.6983 166.984 88.6876 168.528C91.3625 170.604 93.4234 171.577 94.196 171.522C94.8899 171.472 87.606 171.323 85.0802 170.879C82.5529 170.434 84.1724 171.555 81.0506 171.999C77.9288 172.444 79.4821 176.86 78.144 171.67C76.8058 166.481 72.2948 163.624 74.3779 162.773C75.8305 162.18 79.7787 155.953 79.7787 155.953L81.0685 159.483Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8585 147.945C81.8585 147.945 83.4932 145.128 82.453 143.942C81.4129 142.756 80.6693 142.46 80.2237 143.349C79.7782 144.238 81.1149 143.645 81.1149 144.535C81.1149 145.426 81.8585 147.945 81.8585 147.945Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53 110.137C127.629 110.199 126.402 111.405 126.003 112.212C125.406 113.425 125.922 114.325 124.368 114.733C121.544 115.475 120.652 117.106 120.355 118.144C120.059 119.181 120.059 114.882 120.652 114.289C121.245 113.696 119.314 117.699 117.382 119.923C115.45 122.147 115.287 123.15 115.764 126.826C115.996 128.605 116.491 130.845 116.491 130.845C116.491 130.845 112.627 127.336 111.735 119.774C110.843 112.212 108.018 111.471 110.397 109.247C112.775 107.023 114.41 106.133 117.382 102.722C120.355 99.3124 122.436 97.0885 126.895 97.533C131.354 97.9775 134.03 98.8679 134.03 98.8679C134.03 98.8679 132.396 98.2747 131.503 99.3123C130.612 100.35 135.367 99.6082 135.367 99.6082C135.367 99.6082 135.664 100.497 134.773 100.943C133.881 101.388 137.002 100.647 139.826 105.095C142.65 109.543 142.65 119.181 142.65 120.515C142.65 121.848 141.46 122.145 141.609 124.667C141.758 127.188 140.42 115.474 138.786 113.546C137.151 111.618 135.516 107.022 132.691 108.95C130.721 110.294 129.533 110.066 128.529 110.136L128.53 110.137Z",
    fill: "url(#paint4_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.072 128.212C133.072 128.212 133.468 127.125 134.856 126.828C136.244 126.532 138.125 126.532 138.819 125.939C139.513 125.346 137.432 127.224 136.54 127.619C135.649 128.014 133.369 127.619 133.072 128.212Z",
    fill: "url(#paint5_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.683 144.785C85.1272 145.55 83.0924 150.65 85.9784 149.913C90.7032 148.709 87.9759 146.686 95.3094 144.709C102.642 142.731 82.5034 141.028 84.683 144.785Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.178 130.125C125.178 130.125 124.424 129.429 123.048 129.77C121.673 130.111 119.951 130.893 119.104 130.711C118.256 130.53 120.835 131.152 121.794 131.095C122.753 131.039 124.693 129.78 125.18 130.125H125.178Z",
    fill: "url(#paint6_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.437 139.839C111.207 141.108 109.356 140.715 108.168 141.223C104.34 142.857 99.1499 145.078 93.3049 145.573C88.5939 145.971 88.5153 145.902 85.8735 145.178C83.2317 144.453 83.0993 141.026 81.1169 140.433C79.1346 139.84 76.9549 144.091 77.5495 146.759C78.1441 149.428 80.9362 153.159 79.9278 156.578C77.9454 163.299 74.7091 163.365 74.7091 163.365C74.7091 163.365 72.4964 162.377 69.1276 165.343C65.7588 168.309 65.0649 169.297 65.0649 169.297C65.0649 169.297 61.4975 172.46 59.1192 173.843C56.7409 175.228 64.2717 164.947 63.6771 159.412C63.0826 153.877 65.6595 139.642 72.0011 137.863C78.3427 136.083 76.7577 137.071 76.7577 137.071C76.7577 137.071 79.9292 129.559 83.0993 127.385C86.2708 125.21 92.2151 123.628 95.5853 123.431C98.954 123.233 105.395 128.868 107.575 131.437C109.754 134.008 111.095 134.684 111.439 135.885C111.835 137.269 111.702 138.391 111.439 139.839H111.437Z",
    fill: "url(#paint7_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0108 160.413C81.0108 160.413 82.1889 162.316 82.1337 161.989C81.9861 161.127 80.5224 157.602 80.997 156.517C81.6619 154.994 81.3322 154.113 81.1308 153.448C80.9556 152.872 79.9375 157.106 79.9375 157.106L81.0121 160.415L81.0108 160.413Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.452 125.888C131.286 125.801 131.209 125.604 131.263 125.425C131.361 125.097 131.522 124.44 132.582 123.839C135.141 122.387 138.961 123.045 139.555 123.539C139.555 123.539 136.843 123.403 134.664 124.49C132.676 125.482 132.198 126.28 131.453 125.888H131.452Z",
    fill: "url(#paint8_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 126.891C125.46 126.891 124.664 125.511 122.55 125.84C120.909 126.096 118.186 127.191 117.634 128.542C117.634 128.542 120.04 127.49 121.921 127.392C123.804 127.293 125.261 127.881 125.458 126.891H125.46Z",
    fill: "url(#paint9_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.631 154.91C105.631 154.91 105.368 156.18 106.038 156.216C106.88 156.262 106.958 155.236 106.898 155.195L105.632 154.91H105.631Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7954 203.7C50.7954 203.7 43.6605 225.941 43.9585 228.907C44.2551 231.872 41.2836 238.099 46.6334 239.583C51.9845 241.065 66.8474 236.915 70.1182 234.542C73.3877 232.17 63.429 239.732 55.5519 241.66C47.6749 243.587 46.3368 244.625 43.6605 243.439C40.9857 242.253 38.904 236.915 40.9857 226.833C43.066 216.75 48.7151 203.109 48.7151 203.109L50.7954 203.702V203.7Z",
    fill: "#BB896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.326 143.893C145.755 142.718 164.945 146.068 166.927 147.65C168.91 149.232 171.684 161.489 174.458 170.583C177.232 179.676 181.989 189.561 180.8 195.097C180.8 195.097 176.341 191.34 169.206 190.945C164.168 190.666 161.378 206.069 166.405 233.868C166.972 237.002 168.028 245.675 166.134 248.03C166.134 248.03 157.365 247.906 151.271 248.03C136.705 248.325 111.054 252.075 109.951 252.626C108.366 253.417 109.654 201.323 109.654 201.323C109.654 201.323 109.291 185.672 103.346 182.508C97.4 179.344 99.1838 178.028 99.5479 168.703C99.5479 168.703 105.691 160.861 106.285 158.719C106.717 157.162 107.673 151.998 108.465 150.02C109.258 148.043 120.951 144.682 121.743 146.263C122.536 147.844 120.554 152.984 123.328 158.916C126.102 164.847 130.759 174.335 130.759 174.335C130.759 174.335 143.741 148.239 145.326 143.889V143.893Z",
    fill: "url(#paint10_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.552 145.011C238.025 142.424 233.441 143.684 230.956 145.378C224.885 149.519 211.938 158.335 209.527 159.838C206.355 161.815 194.069 201.353 194.465 203.331C194.861 205.308 217.058 234.963 219.04 230.218C221.022 225.473 223.797 216.775 223.797 216.775C223.797 216.775 229.345 234.172 229.345 235.753C229.345 237.334 235.291 231.799 238.461 233.381C241.632 234.962 256.297 244.847 261.45 245.243C266.603 245.638 265.811 269.758 263.829 273.317C261.846 276.875 332.399 271.339 337.155 263.037C341.912 254.733 337.551 185.144 337.155 179.609C336.759 174.074 330.418 162.607 324.075 158.653C317.733 154.699 293.159 136.906 283.249 134.929C273.34 132.952 253.522 169.329 253.522 169.329C253.522 169.329 243.217 181.981 240.442 176.446C238.134 171.842 244.389 153.21 239.551 145.012L239.552 145.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.913 112.081C217.913 112.081 218.446 108.24 220.428 107.449C222.41 106.658 229.148 115.753 234.499 112.787C239.85 109.822 244.012 108.834 245.993 105.473C247.976 102.112 245.795 105.671 241.237 106.857C236.679 108.044 245.399 105.276 248.173 101.322C250.947 97.3688 249.163 99.345 251.344 102.707C253.524 106.067 256.657 107.412 257.846 109.981C259.035 112.552 259.569 111.758 260.957 109.782C262.345 107.804 257.886 103.893 261.255 100.731C264.624 97.567 267.469 99.1551 268.587 101.719C270.569 106.266 269.975 109.725 269.975 109.725C269.975 109.725 272.452 107.946 271.907 96.6766C271.5 88.2559 267.3 88.6206 263.732 84.0738C260.165 79.527 263.832 79.5766 258.481 76.6109C253.129 73.6453 240.347 68.2577 232.965 72.8059C225.334 77.5068 215.674 83.7284 215.08 90.4509C214.485 97.172 209.94 102.729 213.903 106.879C217.866 111.031 217.916 112.084 217.916 112.084L217.913 112.081Z",
    fill: "url(#paint11_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.757 128.997C271.757 128.997 264.326 139.97 259.271 142.935C254.218 145.901 249.682 151.166 248.372 150.942C244.605 150.299 242.656 147.022 241.897 146.758C241.139 146.494 241.733 153.611 241.733 163.1C241.733 172.588 242.922 177.631 242.922 177.631C242.922 177.631 254.814 161.321 258.083 155.389C261.353 149.458 270.866 135.818 271.757 128.996V128.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.03 158.948L248.916 151.534C246.588 151.386 241.897 146.758 241.897 146.758L242.03 158.948Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.003 155.984C245.003 155.984 244.706 160.729 245.598 161.322C246.489 161.915 241.436 169.033 241.436 169.033L242.921 177.633L252.136 165.474C252.136 165.474 249.758 162.213 250.947 160.729C252.136 159.247 255.109 154.502 255.109 154.502L252.136 149.164C252.136 149.164 247.678 151.832 245.002 155.984H245.003Z",
    fill: "url(#paint12_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.308 157.268L248.917 151.535C248.917 151.535 263.732 139.08 267.892 133.15L272.054 127.219C272.054 127.219 260.361 153.71 255.308 157.268Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.351 126.031C272.351 126.031 283.251 132.752 285.035 133.939C286.818 135.125 281.567 147.678 278.892 149.755C276.217 151.83 268.784 149.459 268.784 149.459L271.757 156.279L243.219 192.458C243.219 192.458 242.823 179.213 242.922 177.631C243.041 175.736 259.569 153.018 272.351 126.033V126.031Z",
    fill: "url(#paint13_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.224 142.935C237.224 142.935 230.733 153.907 230.733 158.948C230.733 163.989 231.625 163.989 231.625 163.989C231.625 163.989 235.787 161.913 237.272 161.616C238.758 161.32 232.219 171.402 232.219 171.402C232.219 171.402 242.623 189.787 243.218 193.05C243.813 196.312 241.896 146.757 241.896 146.757L237.223 142.934L237.224 142.935Z",
    fill: "url(#paint14_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.507 141.033C142.905 141.338 144.045 142.353 144.492 143.71C145.264 146.056 146.213 150.032 145.749 154.494C145.005 161.611 144.263 168.431 145.452 171.1C146.641 173.768 147.087 170.211 147.087 170.211C147.087 170.211 146.343 161.611 147.532 157.459C148.721 153.307 147.236 141.446 144.361 140.244C142.532 139.478 140.918 139.469 140.918 139.469L140.397 140.967L141.507 141.032V141.033Z",
    fill: "url(#paint15_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.464 175.082C108.464 175.082 112.181 188.278 114.707 192.727C117.552 197.736 118.274 198.361 120.949 197.323C123.624 196.286 123.178 195.693 124.516 196.434C125.854 197.176 124.962 197.323 123.178 198.065C121.394 198.807 118.422 199.251 116.787 198.214C115.152 197.176 109.206 183.238 107.721 175.083H108.464V175.082Z",
    fill: "url(#paint16_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.034 173.266C118.034 173.266 121.819 186.371 122.077 191.392C122.368 197.045 122.111 197.924 119.443 198.297C116.775 198.67 116.828 197.949 116.138 199.221C115.448 200.491 116.237 200.196 118.042 199.99C119.846 199.783 122.448 198.76 123.223 197.093C123.999 195.427 121.613 180.63 118.627 172.914L118.034 173.266Z",
    fill: "url(#paint17_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3776 162.181C74.3776 162.181 79.7288 167.716 80.5206 170.682C81.3138 173.647 85.8717 172.263 88.0514 175.427C90.231 178.59 92.6093 186.103 93.2038 188.079C93.7984 190.056 94.1943 179.973 94.9876 179.182C95.7808 178.391 96.5726 178.787 101.131 179.775C105.688 180.763 113.767 196.374 113.568 198.154C113.37 199.933 110.006 210.064 110.006 210.064C110.006 210.064 106.395 206.311 96.5726 209.826C88.5618 212.693 77.1987 218.473 71.0075 220.007C66.9917 221.003 63.6754 222.082 63.6754 222.082C63.6754 222.082 63.2795 218.325 64.0713 214.57C64.8645 210.813 50.4955 205.179 44.3525 208.145C44.3525 208.145 52.5772 180.17 54.7568 177.996C56.9365 175.821 60.7025 170.088 67.0441 166.133C72.0863 162.99 74.0976 162.426 74.3763 162.18L74.3776 162.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8469 213.778C67.6401 210.022 53.2711 204.388 47.1281 207.353C47.1281 207.353 55.3528 179.379 57.5324 177.204C59.712 175.03 63.4781 169.297 69.8197 165.342C71.8131 164.099 73.3306 163.261 74.4577 162.685C74.1611 162.364 73.9817 162.18 73.9817 162.18C73.7031 162.426 71.6904 162.99 66.6496 166.133C60.308 170.087 56.5419 175.82 54.3623 177.996C52.1827 180.17 43.958 208.145 43.958 208.145C50.101 205.179 64.47 210.813 63.6768 214.57C62.8835 218.327 63.2808 222.082 63.2808 222.082C63.2808 222.082 64.5776 221.629 66.4275 221.02C66.3558 220.095 66.1806 216.937 66.8483 213.778H66.8469Z",
    fill: "url(#paint18_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6587 249.729L62.3871 239.432C62.3871 239.432 74.3709 232.664 81.016 228.905C87.6556 225.148 95.1974 221.661 98.2572 220.206C101.792 218.526 105.589 216.449 105.589 216.449C105.589 216.449 107.274 217.338 107.274 223.269C107.274 229.201 109.354 251.589 107.274 253.813C105.49 255.72 75.5849 266.325 65.5075 263.748C63.6673 263.277 61.5235 251.618 61.6573 249.727L61.6587 249.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6154 263.811C64.7751 263.34 63.9529 251.569 64.0868 249.678L64.7158 238.871C64.7158 238.871 76.5796 232.199 83.4441 228.854C90.612 225.361 96.7729 221.675 99.9927 220.616C102.8 219.694 104.963 219.233 106.681 218.838C106.482 217.586 105.64 216.398 105.64 216.398C105.64 216.398 101.843 218.474 98.3083 220.155C95.2486 221.61 87.7054 225.097 81.0672 228.854C74.4221 232.614 62.4382 239.382 62.4382 239.382C62.4382 239.382 61.6657 246.796 61.5319 250.066C61.4546 251.96 62.6355 265.743 64.4744 266.214C65.7298 266.534 71.2906 264.616 73.2371 263.812C72.4714 263.763 67.2527 263.976 66.6154 263.812V263.811Z",
    fill: "url(#paint19_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.425 171.967C145.425 171.967 144.236 175.526 145.92 176.119C147.605 176.712 148.993 174.241 149.488 172.362C149.983 170.484 149.289 169.792 148.002 169.99C146.714 170.188 145.425 171.967 145.425 171.967Z",
    fill: "url(#paint20_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.047 171.276C149.737 170.397 150.831 169.903 151.941 170.032C152.504 170.098 153.092 170.321 153.602 170.832C155.088 172.314 155.631 174.835 153.65 177.898C151.668 180.963 147.474 180.612 146.78 178.438C146.087 176.263 146.615 174.734 147.607 173.252C148.114 172.493 148.648 171.785 149.047 171.276Z",
    fill: "url(#paint21_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 154.471C105.085 154.396 105.371 154.536 105.458 154.57C105.863 154.73 106.886 155.012 107.609 154.93C108.522 154.826 107.152 155.501 106.499 155.397C105.953 155.311 105.407 154.822 105.244 154.667C105.212 154.636 105.203 154.598 105.214 154.559L105.061 154.471H105.062Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.414 192.232C136.905 191.574 169.548 189.465 171.784 189.661C174.02 189.858 137.431 231.573 136.212 232.561C134.992 233.55 96.3712 238.096 96.574 236.912C96.7768 235.725 124.913 207.652 136.414 192.232Z",
    fill: "url(#paint22_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.102 210.767C106.434 209.281 105.648 209.123 106.58 208.797C109.59 207.745 115.526 216.275 114.774 217.025C113.784 218.013 107.442 224.932 107.442 224.932C107.442 224.932 108.825 214.597 107.103 210.766L107.102 210.767Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0359 167.519C68.0359 167.519 74.2782 174.339 74.4272 180.419C74.5762 186.499 76.9544 186.35 76.9544 186.35C76.9544 186.35 76.8054 181.012 79.7783 178.937C82.7511 176.862 84.3859 175.971 85.873 176.862C87.3587 177.751 90.6295 185.906 92.1153 188.427C93.601 190.948 93.899 189.613 93.899 189.613C93.899 189.613 90.0846 177.356 88.5479 175.33C87.0125 173.303 81.2654 171.079 78.8871 167.373C76.5088 163.666 74.3789 162.184 74.3789 162.184C74.3789 162.184 66.4025 164.112 68.0373 167.522L68.0359 167.519Z",
    fill: "url(#paint23_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8777 184.26C76.1755 183.951 74.9298 182.788 74.8236 178.441C74.6746 172.361 68.4323 165.541 68.4323 165.541C68.3316 165.332 68.2681 165.128 68.2364 164.93C67.6474 165.616 67.4046 166.417 67.8377 167.32C67.8377 167.32 74.08 174.14 74.229 180.22C74.378 186.3 76.7563 186.151 76.7563 186.151C76.7563 186.151 76.7342 185.356 76.8777 184.26Z",
    fill: "url(#paint24_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.512 186.447C91.0263 183.926 87.7555 175.771 86.2697 174.882C84.784 173.993 83.1479 174.882 80.175 176.958C78.7914 177.924 78.0837 179.597 77.7236 181.109C78.1389 180.186 78.7334 179.329 79.5805 178.737C82.5533 176.662 84.188 175.771 85.6751 176.662C87.1609 177.551 90.4317 185.706 91.9174 188.227C93.4032 190.748 93.7012 189.413 93.7012 189.413C93.7012 189.413 93.4253 188.524 92.9907 187.188C92.8472 186.988 92.6872 186.746 92.512 186.447Z",
    fill: "url(#paint25_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4274 189.299C94.4274 189.299 95.5007 184.851 96.5408 183.961C97.581 183.072 98.2583 182.049 99.2985 184.273C100.339 186.497 100.784 187.388 100.784 187.388C100.784 187.388 99.893 182.049 99.0005 180.419C98.6322 179.746 98.239 179.199 97.9038 178.789C97.4099 178.184 95.6993 178.101 95.1847 178.689C94.7461 179.19 94.3915 180.439 94.3915 181.456C94.3915 183.68 91.4518 192.116 94.4246 189.298L94.4274 189.299Z",
    fill: "url(#paint26_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.094 234.536C126.895 233.943 125.706 232.362 128.084 229.99C130.462 227.617 133.435 228.803 135.615 226.826C137.794 224.848 141.163 222.872 140.371 225.639C139.578 228.407 138.488 233.547 137.349 233.449C136.535 233.379 136.259 234.635 135.07 234.635C133.881 234.635 133.485 234.437 132.692 235.427C131.898 236.416 131.304 235.625 130.313 235.427C129.323 235.229 129.619 236.218 128.43 236.02C127.241 235.822 127.092 234.538 127.092 234.538L127.094 234.536Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.582 210.219C166.582 210.219 164.353 209.626 163.758 211.701C163.164 213.776 164.649 220.005 162.867 222.08C161.083 224.155 164.734 230.054 166.963 230.944C169.192 231.834 167.475 214.518 166.583 210.219",
    fill: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.368 193.977C163.365 193.309 168.53 209.793 169.125 210.386C169.719 210.979 172.692 208.805 172.692 208.805C172.692 208.805 167.341 195.954 164.368 193.978V193.977Z",
    fill: "url(#paint27_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.397 131.194C121.397 131.194 122.04 131.737 122.436 131.671C122.832 131.605 123.096 131.406 123.36 131.144C123.625 130.879 123.69 130.484 123.69 130.484L121.396 131.194H121.397Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.955 127.813C134.955 127.813 135.517 128.671 136.507 128.34C137.009 128.174 137.379 127.051 137.3 127.286C137.3 127.286 135.781 127.846 134.955 127.813Z",
    fill: "#48537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.289 143.25L121.199 142.113C120.019 142.534 116.096 146.166 115.006 147.747C113.123 150.479 111.29 162.03 111.142 165.738C110.993 169.445 108.318 167.666 107.873 170.631C107.427 173.597 107.096 175.475 107.245 175.92C107.394 176.364 109.161 175.591 109.161 175.591C109.161 175.591 109.211 171.077 111.291 170.484C113.372 169.891 115.304 169.149 116.791 171.966C118.277 174.783 117.386 174.041 117.386 174.041L119.466 173.415C119.466 172.229 116.692 167.484 114.413 167.517C111.78 167.556 114.775 154.175 115.503 151.602C116.791 147.055 121.062 144.574 122.29 143.249L122.289 143.25Z",
    fill: "url(#paint28_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.142 194.428C168.142 194.428 167.547 195.91 164.873 196.059C162.198 196.208 157.441 199.618 158.481 200.359C159.521 201.101 159.67 204.511 161.603 203.918C163.536 203.325 171.711 193.539 168.143 194.428H168.142Z",
    fill: "#FFE3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.799 62.1312C328.122 62.1312 319.434 53.2014 319.434 42.2238C319.434 31.2463 328.12 22.3164 338.799 22.3164C349.478 22.3164 358.165 31.2463 358.165 42.2238C358.165 53.2014 349.478 62.1312 338.799 62.1312ZM338.799 25.5916C329.932 25.5916 322.717 33.0531 322.717 42.2252C322.717 51.3972 329.932 58.8587 338.799 58.8587C347.667 58.8587 354.882 51.3972 354.882 42.2252C354.882 33.0531 347.667 25.5916 338.799 25.5916Z",
    fill: "url(#paint29_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1464 96.6916C66.3669 96.6916 64.5514 96.3944 62.7732 95.7668C58.8127 94.3714 55.615 91.5682 53.7692 87.8732C51.9179 84.1659 51.6475 80.0071 53.0091 76.1608C55.8329 68.1874 65.8551 63.5525 74.037 66.4355C77.9369 67.8103 80.9552 70.747 82.5361 74.7076C84.0177 78.4204 84.0826 82.7649 82.7155 86.6292C80.5193 92.8329 74.5598 96.6916 68.1464 96.6916ZM68.9686 67.8117C63.0657 67.8117 57.0234 71.4956 55.1101 76.9012C53.9513 80.1737 54.183 83.7186 55.7626 86.8824C57.349 90.0586 60.1011 92.4696 63.514 93.6723C70.5454 96.1508 78.2169 92.6581 80.6145 85.8888C81.805 82.5255 81.7512 78.7493 80.4669 75.5291C79.1274 72.1727 76.5808 69.6874 73.2962 68.53C71.907 68.0401 70.442 67.8103 68.9686 67.8103V67.8117Z",
    fill: "url(#paint30_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.993 231.633C354.515 231.633 350.872 227.888 350.872 223.285C350.872 218.682 354.515 214.938 358.993 214.938C363.471 214.938 367.114 218.682 367.114 223.285C367.114 227.888 363.471 231.633 358.993 231.633ZM358.993 216.31C355.274 216.31 352.249 219.439 352.249 223.285C352.249 227.132 355.274 230.261 358.993 230.261C362.712 230.261 365.738 227.132 365.738 223.285C365.738 219.439 362.712 216.31 358.993 216.31Z",
    fill: "url(#paint31_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.445 48.241H161.362V41.7855H154.981V39.7075H161.362V33.4336H163.445V39.7075H169.825V41.7855H163.445V48.241Z",
    fill: "url(#paint32_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.795 214.783L27.8209 214.699V210.048H22.249V207.6H27.8209V202.121H30.3647L29.8874 207.6H35.3696V210.048H30.195L29.795 214.783Z",
    fill: "url(#paint33_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.061 127.209L350.088 127.126V122.474H344.517V120.027H350.088V114.547H352.632L352.155 120.027H357.637V122.474H352.463L352.061 127.209Z",
    fill: "url(#paint34_linear_7614_50254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.563 205.66C111.563 205.66 112.768 214.217 111.965 214.418C111.162 214.618 110.009 210.064 110.009 210.064L111.563 205.66Z",
    fill: "#CC9B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 203.331C154.436 203.331 193.416 200.761 194.072 201.75C208.737 223.892 225.682 234.567 225.682 234.567C225.682 234.567 207.861 228.128 209.481 231.899C210.819 235.013 213.048 237.237 213.048 237.237C213.048 237.237 209.332 237.336 208.936 239.51C208.54 241.685 211.786 245.157 212.008 245.541C212.999 247.254 211.122 248.096 211.843 250.253C212.041 250.846 193.479 253.35 193.479 253.35C193.479 253.35 159.589 215.788 154.437 203.333L154.436 203.331Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7614_50254",
    x1: 184.702,
    y1: 383.454,
    x2: 212.26,
    y2: 11.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61CDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#58B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#48D6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C2F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#63C0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AB1C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7614_50254",
    x1: 285.142,
    y1: 290.881,
    x2: 285.716,
    y2: 168.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7614_50254",
    x1: 259.056,
    y1: 144.652,
    x2: 240.464,
    y2: 112.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7614_50254",
    x1: 243.931,
    y1: 153.351,
    x2: 225.339,
    y2: 121.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7614_50254",
    x1: 116.171,
    y1: 82.2852,
    x2: 141.343,
    y2: 161.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6F8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D1F5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C2EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AAE2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7614_50254",
    x1: 134.89,
    y1: 114.467,
    x2: 139.032,
    y2: 160.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7614_50254",
    x1: 120.74,
    y1: 115.728,
    x2: 124.882,
    y2: 162.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7614_50254",
    x1: 42.5209,
    y1: 201.421,
    x2: 79.43,
    y2: 153.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7614_50254",
    x1: 134.275,
    y1: 119.555,
    x2: 138.619,
    y2: 138.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7614_50254",
    x1: 120.408,
    y1: 122.655,
    x2: 124.753,
    y2: 142.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7614_50254",
    x1: 175.711,
    y1: 0.475091,
    x2: 135.472,
    y2: 206.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C7E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8E3E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A0D9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7FCBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7614_50254",
    x1: 210.6,
    y1: -17.0499,
    x2: 242.96,
    y2: 103.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7614_50254",
    x1: 232.197,
    y1: 106.338,
    x2: 246.994,
    y2: 159.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7614_50254",
    x1: 296.422,
    y1: 301.063,
    x2: 207.061,
    y2: -83.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7614_50254",
    x1: 271.575,
    y1: 306.839,
    x2: 182.214,
    y2: -77.5809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7614_50254",
    x1: 140.397,
    y1: 155.782,
    x2: 147.943,
    y2: 155.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7614_50254",
    x1: 103.073,
    y1: 147.913,
    x2: 133.263,
    y2: 236.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7614_50254",
    x1: 104.15,
    y1: 148.18,
    x2: 134.34,
    y2: 236.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7614_50254",
    x1: 106.054,
    y1: 202.848,
    x2: 23.2451,
    y2: 179.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7614_50254",
    x1: 110.367,
    y1: 275.632,
    x2: 66.8154,
    y2: 216.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7614_50254",
    x1: 135.011,
    y1: 137.006,
    x2: 165.201,
    y2: 225.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7614_50254",
    x1: 138.299,
    y1: 139.259,
    x2: 166.196,
    y2: 220.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7614_50254",
    x1: 299.336,
    y1: 226.9,
    x2: 118.601,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7614_50254",
    x1: 118.992,
    y1: 341.474,
    x2: 29.631,
    y2: -42.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7614_50254",
    x1: 84.4581,
    y1: 157.928,
    x2: 69.0523,
    y2: 180.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7614_50254",
    x1: 97.8052,
    y1: 166.958,
    x2: 82.3994,
    y2: 189.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7614_50254",
    x1: 132.343,
    y1: 339.634,
    x2: 42.2088,
    y2: -48.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7614_50254",
    x1: 172.601,
    y1: 171.449,
    x2: 168.263,
    y2: 203.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#98A9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#93A4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8897C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#59658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7614_50254",
    x1: 107.207,
    y1: 159.085,
    x2: 122.289,
    y2: 159.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7614_50254",
    x1: 333.414,
    y1: 23.0967,
    x2: 344.136,
    y2: 61.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7614_50254",
    x1: 83.259,
    y1: 76.9452,
    x2: 52.8366,
    y2: 85.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFEFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B9ECE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ABE4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#92D8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C08B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7614_50254",
    x1: 356.735,
    y1: 215.264,
    x2: 361.231,
    y2: 231.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7614_50254",
    x1: 154.981,
    y1: 40.8373,
    x2: 169.825,
    y2: 40.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFEFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B9ECE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ABE4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#92D8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C08B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7614_50254",
    x1: 22.249,
    y1: 208.451,
    x2: 35.3696,
    y2: 208.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7614_50254",
    x1: 344.517,
    y1: 120.879,
    x2: 357.637,
    y2: 120.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FCE354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFD542"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7614_50254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 283,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.cc7cbe0be91faffb919707359b62a0d3.svg";
export { ForwardRef as ReactComponent };